<template>
  <v-dialog v-model="dialog" :width="dialogWidth" :fullscreen="fullscreen">
    <v-card class="theme--dark imagem-carousel-dialog">
      <div class="imagem-carousel-dialog__header">
        <v-card-title class="justify-space-between py-0">
          <span v-if="temImagens">
            {{ carouselIndex + 1 }} / {{ imagens.length }}
          </span>
          <span v-else>{{ titulo }}</span>
          <v-btn icon @click="close" aria-label="Fechar">
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
      </div>

      <v-card class="theme--dark imagem-carousel-dialog__content">
        <v-card-media v-if="!temImagens" class="text-sm-center pa-3">
          <span>Nenhuma imagem para exibir.</span>
        </v-card-media>

        <div v-else class="imagem-carousel-dialog__viewport">
          <v-carousel
              v-model="carouselIndex"
              class="imagem-carousel-dialog__carousel"
              :cycle="false"
              hide-delimiters
              :height="alturaCarousel"
          >
            <v-carousel-item
                v-for="(imagem, i) in imagens"
                :key="i"
            >
              <div class="imagem-carousel-dialog__item">
                <img
                    class="imagem-carousel-dialog__image"
                    :src="resolverSrcImagem(imagem.base64)"
                    :alt="imagem.descricaoImagem || `Imagem ${i + 1}`"
                />
              </div>
            </v-carousel-item>
          </v-carousel>
        </div>
      </v-card>

      <div class="imagem-carousel-dialog__thumbnails" v-if="temImagens">
        <az-thumbnails-bar
            v-model="carouselIndex"
            :imagens="imagensFormatadas"
            :show-description="false"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import AzThumbnailsBar from './AzThumbnailsBar'

export default {
    name: 'ImagemCarouselDialog',
    components: {
        AzThumbnailsBar
    },
    props: {
        titulo: {
            type: String,
            default: 'Imagens do item'
        },
        dialogWidth: {
            type: String,
            default: '80%'
        },
        fullscreen: {
            type: Boolean,
            default: false
        },
        imagensProp: {
            type: Array,
            default: () => []
        },
        defaultMime: {
            type: String,
            default: 'image/jpeg'
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            imagens: [],
            carouselIndex: 0,
        }
    },
    computed: {
        temImagens() {
            return this.imagens && this.imagens.length > 0
        },
        imagensFormatadas() {
            return this.imagens.map(imagem => ({
                ...imagem,
                src: this.resolverSrcImagem(imagem.base64)
            }))
        },
        alturaCarousel() {
            return this.fullscreen ? 'calc(100vh - 170px)' : '60vh'
        }
    },
    methods: {
        async open({ index = 0 } = {}) {
            this.dialog = true
            this.carouselIndex = Number.isFinite(index) ? index : 0
            this.imagens = this.imagensProp
        },
        close() {
            this.dialog = false
            this.imagens = []
            this.carouselIndex = 0
        },
        resolverSrcImagem(base64) {
            if (!base64) return ''
            return `data:${this.defaultMime};base64,${base64}`
        }
    }
}
</script>

<style scoped lang="stylus">
.imagem-carousel-dialog
  display: flex
  flex-direction: column
  height: 100%
  background: #424242

.imagem-carousel-dialog__header
  flex: 0 0 auto

.imagem-carousel-dialog__content
  flex: 1 1 auto
  min-height: 0
  box-shadow: none
  background: transparent
  display: flex
  flex-direction: column

.imagem-carousel-dialog__viewport
  flex: 1 1 auto
  min-height: 0
  display: flex
  align-items: stretch
  justify-content: stretch

.imagem-carousel-dialog__carousel
  width: 100%
  box-shadow: none

.imagem-carousel-dialog /deep/ .v-window,
.imagem-carousel-dialog /deep/ .v-window__container,
.imagem-carousel-dialog /deep/ .v-carousel__item
  height: 100% !important

.imagem-carousel-dialog__item
  width: 100%
  height: 100%
  display: flex
  align-items: center
  overflow: hidden
  justify-content: center
  padding: 16px 48px
  box-sizing: border-box

.imagem-carousel-dialog__image
  width: 100%
  height: 100%
  max-width: calc(100vw - 120px)
  max-height: calc(100vh - 200px)
  object-fit: contain
  object-position: center
  display: block

.imagem-carousel-dialog__thumbnails
  flex: 0 0 auto
  padding: 0 0 12px

@media (max-width: 960px)
  .imagem-carousel-dialog__item
    padding: 12px 36px

@media (max-width: 600px)
  .imagem-carousel-dialog__item
    padding: 8px 24px
</style>
